import { AnimatePresence, motion } from 'framer-motion';
import React, { useContext, useState } from 'react'
import { TfiAngleRight } from "react-icons/tfi";
import { BiCog } from 'react-icons/bi';
import { Link, useLocation } from 'react-router-dom';

const NestedLink = ({ Icon, title, to, links }) => {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  return (
    <>
    <div className='relative'>

    <button onClick={() => setOpen(!open)} className={`mb-2 mx-auto w-[90%] rounded-[10px] hover:bg-primary group flex space-x-2 py-3 px-4 items-center justify-between ${open ? "bg-primary" : ""}`}>
      <div className='flex items-center space-x-2'>
        {/* <img src={icon} className={`flex-shrink-0 mr-3 w-[20px] ${open ? "" : "opacity-[0.65]"}`} /> */}
        <Icon className={`flex-shrink-0 group-hover:text-white text-xl ${open ? "text-white" : "text-primary/80"} `}/>
        <span className={`text-sm font-medium group-hover:text-white ${open ? "text-white" : "text-primary/80"}`}>
          {
            title
          }
        </span>
      </div>
      <TfiAngleRight className={`flex-shrink-0 group-hover:text-white text-lg ${open ? "rotate-[90deg] text-white" : "text-primary/80 rotate=[0deg]"}`} />
    </button>
      <AnimatePresence>
        {
          open &&
          <motion.div
            initial={{ height: "0" }}
            animate={{ height: "auto" }}
            exit={{ height: "0" }}
            className="mb-2 pl-5 overflow-hidden w-[90%] mx-auto relative"
          >
           <div className='border-l-2 border-dashed border-primary/20 space-y-1'>
            {
                links.map((item, index) => (
                    <Link key={index} to={item.to} className={`mb-2 transition-all  w-[90%] mx-auto group hover:bg-primary rounded-lg justify-start flex items-center py-3 px-3 ${item.to === pathname ? "bg-primary" :""}`}>
                      <span className={`text-sm font-regular ${item.to === pathname ? "font-medium text-white" : "text-primary/80 group-hover:text-white group-hover:font-medium"}`}>
                        {
                          item.title
                        }
                      </span>
                    </Link>
                ))
              }
           </div>
          </motion.div>

        }
      </AnimatePresence>
    </div>

    </>
  )
}

export default NestedLink